<article class="hit" *ngIf="item">
  <ng-template #hitBody>
    <div class="hit-content">
      <div class="hit-breadcrumb" *ngIf="showBreadcrumb">
        {{ breadcrumb }}
      </div>
      <h3 class="hit-name">{{ item.name || '-' }}</h3>
      <p class="hit-description" *ngIf="description">{{ description }}</p>
      <div class="institution-footer" *ngIf="item.typeId === '2' && (metaBadges.length || institutionStatChips.length); else defaultMetaBadges">
        <div class="hit-meta-container hit-meta-container--footer" *ngIf="metaBadges.length">
          <span
            *ngFor="let badge of metaBadges"
            class="hit-meta-badge"
            [ngClass]="badge.cssClass"
            [attr.aria-label]="badge.label"
            [attr.title]="badge.label"
          >
            <span
              *ngIf="badge.icon"
              class="material-symbols-outlined hit-meta-icon"
              aria-hidden="true"
            >
              {{ badge.icon }}
            </span>
            <span *ngIf="badge.showLabel" class="hit-meta-label">{{ badge.displayLabel | capitalize }}</span>
          </span>
        </div>
        <div class="institution-stats" *ngIf="institutionStatChips.length">
          <span
            *ngFor="let statChip of institutionStatChips"
            class="institution-stat-chip hit-meta-badge"
            [ngClass]="statChip.cssClass"
          >
            {{ statChip.label }}
          </span>
        </div>
      </div>

      <ng-template #defaultMetaBadges>
        <div class="hit-meta-container" *ngIf="metaBadges.length">
          <span
            *ngFor="let badge of metaBadges"
            class="hit-meta-badge"
            [ngClass]="badge.cssClass"
            [attr.aria-label]="badge.label"
            [attr.title]="badge.label"
          >
            <span
              *ngIf="badge.icon"
              class="material-symbols-outlined hit-meta-icon"
              aria-hidden="true"
            >
              {{ badge.icon }}
            </span>
            <span *ngIf="badge.showLabel" class="hit-meta-label">{{ badge.displayLabel | capitalize }}</span>
          </span>
        </div>
      </ng-template>
    </div>
  </ng-template>

  <ng-container *ngIf="resultLink as link; else plainHit">
    <a
      class="hit-link"
      [href]="link.href"
      [target]="link.target"
      [attr.rel]="link.rel"
      (click)="onLinkClick()"
    >
      <ng-container *ngTemplateOutlet="hitBody"></ng-container>
    </a>
  </ng-container>

  <ng-template #plainHit>
    <ng-container *ngTemplateOutlet="hitBody"></ng-container>
  </ng-template>
</article>
